import { Outlet } from "react-router";

import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const BillingCallsLayout = () => {
    const navList = useNav();
    let { billingCallBottomNav, topBillingNav } = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={billingCallBottomNav} topTabs={topBillingNav} />
            <Outlet />
        </div>
    );
}

export default BillingCallsLayout;